"use client";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { BookOpenTextIcon } from "lucide-react";

type LearnButtonProps = {
  /** Accessible name, e.g. "Learn about agents". */
  label: string;
  onClick: () => void;
};

/** Header icon that opens a page's documentation. Sits first in PageHeader `actions`. */
export function LearnButton({ label, onClick }: LearnButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={label}
          className="size-9 text-muted-foreground"
          onClick={onClick}
        >
          <BookOpenTextIcon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">Learn</TooltipContent>
    </Tooltip>
  );
}
